<template>
  <div class="flex-grow"></div>
</template>

<script>
export default {}
</script>
